import { render, staticRenderFns } from "./PercentageBackground.vue?vue&type=template&id=3c393202&"
import script from "./PercentageBackground.vue?vue&type=script&lang=js&"
export * from "./PercentageBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports